import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { debounceTime, tap } from 'rxjs';
import { SubSink } from 'subsink';

import { ProductSearchActions } from '@search/store/search.slice';

import { ProductSearchSelectors } from './../../store/search.slice';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  searchValueSearchText = '';

  searchControl = new FormControl('');

  suggestions$ = this.store.select(
    ProductSearchSelectors.selectProductSuggestionsList
  );

  constructor(private router: Router, private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(ProductSearchActions.getSearchedWords.trigger());

    this.subs.add(
      this.store
        .select(ProductSearchSelectors.selectSearchValue)
        .subscribe((value) => {
          if (this.searchValueSearchText !== (value.searchText ?? '')) {
            this.searchValueSearchText = value.searchText ?? '';
            if (this.router.url.includes('/search')) {
              this.searchControl.setValue(this.searchValueSearchText);
            }
          }
        })
    );

    this.subs.add(
      this.searchControl.valueChanges
        .pipe(
          tap((value) => {
            this.searchValueSearchText = value ?? '';
            this.store.dispatch(
              ProductSearchActions.updateSearchValue.trigger({
                filter: {
                  searchText: value ?? undefined,
                },
              })
            );
          }),
          debounceTime(200)
        )
        .subscribe((value) => {
          this.store.dispatch(
            ProductSearchActions.getProductSuggestions.trigger({
              searchText: value ?? '',
            })
          );
        })
    );
  }

  search() {
    this.store.dispatch(ProductSearchActions.searchProducts.trigger());
  }

  clear() {
    this.searchControl.reset();
    this.store.dispatch(
      ProductSearchActions.updateSearchValue.trigger({
        filter: {
          searchText: undefined,
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
